import { useQuery } from '@apollo/client';
import { useRouter } from 'next/router';

import { MANAGE, ROUTE_KEY } from '../../routes';
import useFlagOrganization from '../useFlagOrganization';
import LeadershipFeatureFlagQuery from './graphql/LeadershipFeatureFlag.v4.b2b.graphql';
import type {
  LeadershipFeatureFlag,
  LeadershipFeatureFlagVariables,
} from './graphql/types/LeadershipFeatureFlag';

const useManageRoutes = () => {
  const { query } = useRouter();
  const { isActive: hasAutomationRules } = useFlagOrganization({
    flag: 'automation-rules',
  });
  const { isActive: hasCustomFields } = useFlagOrganization({
    flag: 'custom-fields',
  });

  const { slug } = query as { slug: string };

  const { data, loading } = useQuery<
    LeadershipFeatureFlag,
    LeadershipFeatureFlagVariables
  >(LeadershipFeatureFlagQuery, {
    context: { clientName: 'v4.b2b' },
    notifyOnNetworkStatusChange: true,
    variables: { slug },
  });

  let manageNestedRoutes = MANAGE.nested;

  const canUseLeadership =
    data?.b2bOrganizationCurrent?.config?.canUseLeadership || false;

  if (!canUseLeadership && !loading) {
    manageNestedRoutes = manageNestedRoutes.filter(
      route => route.key !== ROUTE_KEY.MANAGE_TEAMS,
    );
  }

  if (!hasAutomationRules) {
    manageNestedRoutes = manageNestedRoutes.filter(
      route => route.key !== ROUTE_KEY.MANAGE_AUTOMATION,
    );
  }

  if (!hasCustomFields) {
    manageNestedRoutes = manageNestedRoutes.filter(
      route => route.key !== ROUTE_KEY.MANAGE_CUSTOM_FIELDS,
    );
  }

  return {
    hasAutomationRules,
    hasCustomFields,
    isTeamsActive: loading ? true : canUseLeadership,
    routes: manageNestedRoutes,
  };
};

export default useManageRoutes;
